/* global AG_FEATURES */
import LocomotiveScroll from 'locomotive-scroll';
import 'imagesloaded';

const $body = $(document.body);

let scroll;

const handleNamedAnchorsScroll = $scrollElementOffset => {
  $("a[href^='#']").click(e => {
    const $clickTarget = $(e.target);
    const id = $clickTarget.attr('href');
    const $scrollTarget = $(id);

    if ($scrollTarget.length) {
      e.preventDefault();

      const scrollOptions = {
        offset: -($scrollElementOffset.outerHeight()),
        callback: () => {
          $body.trigger('scrolledNamedAnchor.ag.locoscroll', [$scrollTarget.get(0)]);
        },
      };

      $body.trigger('scrollNamedAnchor.ag.locoscroll', [$scrollTarget.get(0)]);
      scroll.scrollTo($scrollTarget.get(0), scrollOptions);
    }
  });
};

const handleOffcanvasMenu = () => {
  if (!$('#offcanvas').length) {
    return;
  }

  $body.on('show.ag.offcanvas', () => {
    scroll.stop();
    $body.css('overflow-y', 'hidden');
  });

  $body.on('hide.ag.offcanvas', () => {
    scroll.start();
    $body.css('overflow-y', '');
  });
};


const handleWpcf7Forms = () => {
  const $wpcf7 = $('.wpcf7');

  if (!$wpcf7.length) {
    return;
  }

  const wpcf7EventScrollHandler = (e) => {
    // WPCF7 animates its response output with a slide down of 200 ms
    scroll.update();
    window.setTimeout(() => {
      scroll.update();

      if (e.type === 'wpcf7submit') {
        scroll.scrollTo(e.target);
      }
    }, 500);
  };

  $wpcf7.on('wpcf7beforesubmit', wpcf7EventScrollHandler);
  $wpcf7.on('wpcf7invalid', wpcf7EventScrollHandler);
  $wpcf7.on('wpcf7spam', wpcf7EventScrollHandler);
  $wpcf7.on('wpcf7submit', wpcf7EventScrollHandler);
  $wpcf7.on('wpcf7mailsent', wpcf7EventScrollHandler);
  $wpcf7.on('wpcf7mailfailed', wpcf7EventScrollHandler);
  $wpcf7.on('wpcf7reset', wpcf7EventScrollHandler);
};

const handlePageTransitionThemeSupport = () => {
  if (AG_FEATURES.pageTransition === true) {
    $body.on('beforeRun.ag.handler', () => {
      destroyScroll();
    });

    $body.on('run.ag.handler', () => {
      createScroll();
      window.locoScroll = scroll;
    });
  }
};

let scrollUpdateTimeout = null;
const scrollUpdate = () => {
  if (scroll) {
    if (scrollUpdateTimeout) {
      window.clearTimeout(scrollUpdateTimeout);
    }

    scrollUpdateTimeout = window.setTimeout(() => {
      if (scroll) {
        scroll.update();
      }

      scrollUpdateTimeout = null;
    }, 500);
  }
}

const locomotiveScroll = ($scrollElementOffset = $()) => {
  if (scroll) {
    destroyScroll();
  }

  createScroll();

  $(window).load(scrollUpdate);
  $(document.body).imagesLoaded().progress(scrollUpdate);

  handleNamedAnchorsScroll($scrollElementOffset)
  handleOffcanvasMenu();
  handleWpcf7Forms();

  handlePageTransitionThemeSupport();

  window.locoScroll = scroll;

  return scroll;
};

const createScroll = () => {
  scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
  });

  scroll.on('call', (event, direction, el) => {
    if (el.el) {
      $(el.el).trigger(event);
    }
  });
};

const destroyScroll = () => {
  if (scroll) {
    scroll.destroy();
    scroll = null;
  }
};

export default locomotiveScroll;
